import React from 'react';
import ReactFileReader from 'react-file-reader';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { alert } from '../../../utils/alertDialog';
import * as UserActions from '../../../actions/user';
import * as AuthActions from '../../../actions/auth';
import UserFieldDataTypes from '../../../utils/enums/UserFieldDataTypeEnum';
import UserFieldElement from '../UserFieldElement';
import { base64StringToByteSize } from "../../../../../common/src/util/base64Util";
import Image from '../image/Image';
import {NotificationManager} from "react-notifications";

/** This form is used both on the sign-up page and on the profile-edit page.
 *  (So it must work on both - in particular when the user is not logged in.)
 */
class ProfileForm extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        submitButtonText: PropTypes.string,
        resetPassword: PropTypes.bool,
        profile: PropTypes.object,
        params: PropTypes.object,
    };

    static defaultProps = {
        profile: null,
        submitButtonText: "Save",
        resetPassword: false
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, {
            id: null,
            oldPassword: "",
            password: "",
            repeatPassword: "",
            isBasicFieldsValid: false, // Used to rerender when validity changes after rendering UserField components
            isPasswordFieldsValid: false, // as above
        }, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.profile && nextProps.profile.id !== this.state.id) this.setState(this.getStateFromStore(nextProps));
    }

    // Copies the values from the store to the state - in other words, copies the current values to the editor. (Useful when editing your profile)
    getStateFromStore = props => {
        const user = props.profile;
        return {
            id: user === null ? null : user.id,
            firstName: user === null || user.firstName === null ? "" : user.firstName,
            lastName: user === null || user.lastName === null ? "" : user.lastName,
            email: user === null || user.email === null ? (props.params && props.params.email ? props.params.email : "") : user.email,
            photo: user === null || user.photo === null ? "" : user.photo,
            photoMimeType: user === null || user.photoMimeType === null ? "" : user.photoMimeType,
        };
    };

    checkFieldValidity = () => {
        let test = true;
        this.basicFields.forEach((field) => {
            if (!field.isValid()) test = false;
        });
        const basicValid =  test &&
            (this.props.user.emailExists.name !== this.state.email || !this.props.user.emailExists.exists);

        test = true;
        this.passwordFields.forEach((field) => {
            if (!field.isValid()) test = false;
        });
        const passwordValid =  test && this.state.password === this.state.repeatPassword;

        if (this.state.isBasicFieldsValid !== basicValid || this.state.isPasswordFieldsValid !== passwordValid)
            this.setState({
                isBasicFieldsValid: basicValid,
                isPasswordFieldsValid: passwordValid
            })
    }

    componentDidMount() {
        this.checkFieldValidity();
    }

    componentDidUpdate(prevProps, prevState) {
        this.checkFieldValidity();
    }

    basicFields = [];
    passwordFields = [];
    render() {
        const repeatPasswordErr = this.state.password !== "" && this.state.repeatPassword !== "" && this.state.password !== this.state.repeatPassword;

        return (
            <form className="user-form">
                <div className="content-box editor-container">
                    <div className="sub-container">
                        {!this.props.resetPassword ?
                            <div className="user-fields">
                                <h3>Basic information</h3>
                                <div className="field-row">
                                    <div>
                                        <label htmlFor="email">Email *</label>
                                        <UserFieldElement dataType={UserFieldDataTypes.email} placeholder="Enter email" className="field-1"
                                                          name="email" id="email" maxLength="128" value={this.state.email}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          isError={this.props.user.emailExists.exists} errorMessageOverride={this.props.user.emailExists.exists  ? "The email " + this.props.user.emailExists.name + " is already in use" : null}
                                                          onChange={this.onEmailChange}
                                                          disabled={this.props.profile !== null}
                                                          ref={instance => { this.basicFields[0] = instance; }}
                                        /> {/* TODO: For now e-mail can't be updated. Quickfix: Just disabling the field, until it has been implemented. */}
                                    </div>
                                </div>
                                <div className="field-row">
                                    <label htmlFor="firstName">First name *</label>
                                    <div>
                                        <UserFieldElement dataType={UserFieldDataTypes.string} placeholder="Enter first name" className="field-1"
                                                          name="firstName" id="firstName" maxLength="64" value={this.state.firstName}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.basicFields[1] = instance; }}
                                        />
                                    </div>
                                </div>
                                <div className="field-row">
                                    <div>
                                        <label htmlFor="lastName">Last name *</label>
                                        <UserFieldElement dataType={UserFieldDataTypes.string} placeholder="Enter last name" className="field-1"
                                                          name="lastName" id="lastName" maxLength="64" value={this.state.lastName}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.basicFields[2] = instance; }}
                                        />
                                    </div>
                                </div>
                                {this.props.profile !== null
                                    ? <div className="field-row">
                                        <div>
                                            <button type="submit" className="btn-primary" onClick={this.onSubmit} disabled={!this.state.isBasicFieldsValid}>{this.props.submitButtonText}</button>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                            : ''
                        }
                        {this.props.profile === null || this.props.profile.id == this.props.auth.userId ?
                            <div className="user-fields">
                                <h3>Password</h3>
                                {this.props.profile !== null
                                    ? <div className="field-row">
                                        <div>
                                            <label htmlFor="oldPassword">Old password</label>
                                            <UserFieldElement dataType={UserFieldDataTypes.password}
                                                              placeholder="Enter your old password" className="field-1"
                                                              name="oldPassword" id="oldPassword"
                                                              value={this.state.oldPassword}
                                                              autoCheckErrors={true} hideErrWhenFocused={false}
                                                              hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => {
                                                                  this.passwordFields[0] = instance;
                                                              }}
                                            />
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="field-row">
                                    <div>
                                        <label htmlFor="password">{this.props.profile === null ? 'Password *' : 'New password'}</label>
                                        <UserFieldElement dataType={UserFieldDataTypes.password}
                                                          placeholder="Minimum 6 character incl. digits and letters"
                                                          className="field-1"
                                                          name="password" id="password" value={this.state.password}
                                                          autoCheckErrors={true} required={true}
                                                          hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => {
                                                              this.passwordFields[1] = instance;
                                                          }}
                                        />
                                    </div>
                                </div>
                                <div className="field-row">
                                    <div>
                                        <label htmlFor="repeatPassword">Repeat password *</label>
                                        <UserFieldElement dataType={UserFieldDataTypes.password}
                                                          placeholder="Repeat password" className="field-1"
                                                          name="repeatPassword" id="repeatPassword"
                                                          value={this.state.repeatPassword}
                                                          autoCheckErrors={!repeatPasswordErr}
                                                          isError={repeatPasswordErr}
                                                          errorMessageOverride="Not correctly repeated" required={true}
                                                          hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => {
                                                              this.passwordFields[2] = instance;
                                                          }}
                                        />
                                    </div>
                                </div>
                                <div className="field-row">
                                    <div>
                                        {this.props.profile === null
                                            ? <button type="submit" className="btn-primary" onClick={this.onSubmit}
                                                      disabled={!this.state.isBasicFieldsValid || !this.state.isPasswordFieldsValid}>{this.props.submitButtonText}</button>
                                            : <button type="submit" className="btn-primary"
                                                      onClick={this.onChangePassword}
                                                      disabled={!this.state.isPasswordFieldsValid}>Change password</button>
                                        }
                                    </div>
                                </div>
                            </div>
                            : ''
                        }
                    </div>
                    {!this.props.resetPassword ?
                        <div className="sub-container">
                            <div className="user-fields">
                                <h3>Photo</h3>
                                <div className="user-avatar">
                                    <div className="react-file-reader-container">
                                        <ReactFileReader id="photo2" base64={true} multipleFiles={false}
                                                         handleFiles={this.onPhotoChange}>
                                            <button onClick={e => e.preventDefault()}
                                                    className="btn-primary profile-imgbutton-upload">Upload
                                            </button>
                                        </ReactFileReader>
                                        <button onClick={this.onPhotoRemove}
                                                className="btn-secondary profile-imgbutton-delete">Delete
                                        </button>
                                        <div style={{clear: "both"}} className="profile-imginfo-text">
                                            Max 1MB
                                        </div>
                                        <Image src={"data:" + this.state.photoMimeType + ";base64," + this.state.photo}
                                               size="big" circle={true} whiteIfNoImage={true}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                </div>
            </form>
        )
    }

    onStandardFieldChange = e => {
        const stateVariable = e.target.name; // assuming the "name" attribute and the state variable has the same name.
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckboxChange = e => {
        const stateVariable = e.target.name; // assuming the "name" attribute and the state variable has the same name.
        this.setState({[stateVariable]: e.target.checked});
    };

    onPhotoChange = file => {
        const base64 = file.base64;
        const imageBytesBase64 = base64.substr(base64.indexOf(",")+1); // remove the initial "data:image/png;base64," part.
        const mimeType = base64.substring(base64.indexOf(":")+1, base64.indexOf(";"));

        if (base64StringToByteSize(imageBytesBase64) > 1024*1024) {
            alert("The image is to big", "The profile image may not exceed 1MB. Try upload a smaller image.");
            return;
        }

        this.setState({photo: imageBytesBase64, photoMimeType: mimeType});
    };

    onPhotoRemove = e => {
        e.preventDefault();
        this.setState({photo: "", photoMimeType: ""});
    };

    static emailCheckTimeout = null;
    onEmailChange = (e) => {
        const value = e.target.value;
        const dispatch = this.props.dispatch;

        // check if name already exists (and for another user) - delay a while before sending off the ajax request to avoid spamming the server while typing.
        if (ProfileForm.emailCheckTimeout !== null)
            clearTimeout(ProfileForm.emailCheckTimeout);
        ProfileForm.emailCheckTimeout = setTimeout(() => dispatch(UserActions.checkEmailExists(value, this.props.profile === null ? null : this.props.profile.id)), 1000);

        this.onStandardFieldChange(e);
    };

    onSubmit = e => {
        e.preventDefault();

        if (!this.state.isBasicFieldsValid || (this.props.profile === null && !this.state.isPasswordFieldsValid)) {
            // Set visited to ensure error messages being shown
            this.basicFields.forEach((field) => {
                field.setState({visited: true});
            });
            if (this.props.profile === null) this.passwordFields.forEach((field) => {
                field.setState({visited: true});
            });
            return;
        }

        if (this.props.resetPassword) this.props.onSubmit(this.state.password);
        else this.props.onSubmit({
            email : this.state.email,
            firstName : this.state.firstName,
            lastName : this.state.lastName,
            password : this.props.profile === null ? this.state.password : undefined,
            photo: this.state.photo || null,
        });
    };

    onChangePassword = e => {
        e.preventDefault();

        if (!this.state.isPasswordFieldsValid) {
            // Set visited to ensure error messages being shown
            this.passwordFields.forEach((field) => {
                field.setState({visited: true});
            });
            return;
        }

        this.props.dispatch(AuthActions.changePassword({
            oldPassword: this.state.oldPassword,
            newPassword: this.state.password
        }, () => {
            NotificationManager.success("Your password has been updated.", "Password changed", 4000);
            this.passwordFields.forEach((field) => {
                field.setState({visited: false});
            });
            this.setState({
                oldPassword: "",
                password: "",
                repeatPassword: ""
            });
        }));
    };
}

const mapStateToProps = (state) => ({
    auth: {
        userId: state.auth.userId,
    },
    user: {
        emailExists : state.user.emailExists,
    },
});

export default connect(mapStateToProps)(ProfileForm);


// WEBPACK FOOTER //
// ./src/client/src/components/reusable/profile/ProfileForm.js